import { removeCookie } from '@utils/cookie';
import { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME } from '@utils/const';
import { PATHS } from '@routes/paths';

export const useError = () => {
  const handleError = (err: any) => {
    const {
      response: {
        data: { message, errorCode },
      },
    } = err;

    if (errorCode === 'TKN-0002' || errorCode === 'TKN-0003') {
      removeCookie(ACCESS_TOKEN_NAME, { path: '/' });
      removeCookie(REFRESH_TOKEN_NAME, { path: '/' });
      window.location.replace(PATHS.login);
    }

    console.error(`[${errorCode}] : ${message}`);
  };
  return { handleError };
};
